import api from "../../api/client";
import {
  DatePicker,
  Select,
  Table,
  Card,
  Row,
  Col,
  Statistic,
  Button,
  Tag,
  Space,
  ConfigProvider,
} from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useState, useEffect, useRef } from "react";
import config from "../../config";
import { formatKES } from "../../utils/currency";
import { formatFullDate } from "../../utils/dateUtils";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { ExportOutlined, FilterFilled } from "@ant-design/icons";
import ProTable from "@ant-design/pro-table";
import enUS from "antd/lib/locale/en_US";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function UnifiedSalesDashboard() {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [stats, setStats] = useState({});
  const [stake, setStake] = useState([]);
  const [loading, setLoading] = useState(false);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const [products, setProducts] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);

  useEffect(() => {
    api.get(`/api/saleitems/products`).then((res) => {
      setProducts(res.data);
    });
  }, []);

  useEffect(() => {
    api.get(`/api/saleitems/types`).then((res) => {
      setItemTypes(res.data);
    });
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/api/sales/unified`, {
        params: filters,
      });
      setData(res.data.data);
      setStats(res.data.stats);
    } catch (error) {
    } finally {
      setLoading(false);
    }

    // setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await api.get(`/stakeholders`);
        const data = response.data;
        setStake(data);
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    };

    fetchSuppliers();
  }, []);

  const csvLinkRef = useRef();

  const exportToCSV = () => {
    const csvData = [
      ["TXNID", "Customer", "Quantity", "Invoice Date", "Unit Price", "Amount"],
      ...data.map((item) => [
        item.transactionId,
        item.stakeholderId
          ? stake.find((s) => s.id === item.stakeholderId)?.name ||
            "Walk-in Customer"
          : "Walk-in Customer",
        item.quantity,
        item.recorded || "N/A",
        item.unitPrice || "N/A",
        item.totalCost,
      ]),
    ];

    const csvContent = csvData.map((row) => row.join(",")).join("\n");
    const blob = new Blob(["\ufeff", csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const csvUrl = URL.createObjectURL(blob);
    csvLinkRef.current.href = csvUrl;
    csvLinkRef.current.download = "sfarms.csv";
    csvLinkRef.current.click();
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "TXNID",
          "Customer",
          "Aging Days",
          "Invoice Date",
          "Due Date",
          "By",
          "Farm",
          "Amount",
          "Balance",
          "Status",
          "Notes",
        ],
      ],
      body: data.map((user) => [
        user.transactionId,
        user.stakeholderId
          ? stake.find((s) => s.id === user.stakeholderId)?.name ||
            "Walk-in Customer"
          : "Walk-in Customer",
        user.agingDays,
        user.recorded ? formatFullDate(user.recorded) : "N/A",
        user.dueDate ? formatFullDate(user.dueDate) : "N/A",
        user.servedBy,
        user.farm,
        user.amount.toLocaleString(),
        user.balance || 0,
        user.agingDays <= 0
          ? "Not Due"
          : user.paymentStatus === "fully_paid"
          ? "Fully Paid"
          : "Overdue",
        user.notes || "",
      ]),
    });
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      {/* FILTER SECTION */}

      {/* STATS */}
      <Row gutter={16} style={{ marginBottom: 20 }}>
        <Col span={6}>
          {/* <Card> */}
          <Statistic title="Total Sales Items" value={stats.totalSales || 0} />
          {/* </Card> */}
        </Col>

        <Col span={6}>
          {/* <Card> */}
          <Statistic
            title="Total Revenue"
            value={formatKES(stats.totalAmount || 0)}
          />
          {/* </Card> */}
        </Col>
      </Row>

      {/* SALES TABLE */}
      <ProTable
        rowKey="sourceId"
        dataSource={data}
        bordered
        // pagination={{ pageSize: 20 }}
        rowClassName={(_, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        density="compact"
        defaultSize="small"
        loading={loading}
        search={false}
        columns={[
          {
            title: "Date",
            dataIndex: "recorded",
            render: (value) => (value ? formatFullDate(value) : "-"),
          },
          {
            title: "Product",
            dataIndex: "productName",
          },

          {
            title: "Customer",
            dataIndex: "stakeholderName",
          },
          {
            title: "Quantity",
            dataIndex: "quantity",
            align: "right",
          },
          {
            title: "Unit Price",
            dataIndex: "unitPrice",
            align: "right",
            render: (value) => formatKES(value),
          },
          {
            title: "Total",
            dataIndex: "totalCost",
            align: "right",
            render: (value) => formatKES(value),
          },
          // {
          //   title: "Paid",
          //   dataIndex: "paidAmount",
          //   align: "right",
          //   render: (value) => formatKES(value),
          // },
          // {
          //   title: "Balance",
          //   dataIndex: "balance",
          //   align: "right",
          //   render: (value) => (
          //     <span style={{ color: value > 0 ? "#cf1322" : "#389e0d" }}>
          //       {formatKES(value)}
          //     </span>
          //   ),
          // },
          // {
          //   title: "Status",
          //   dataIndex: "paymentStatus",
          //   render: (status) => {
          //     const color =
          //       status === "fully_paid"
          //         ? "green"
          //         : status === "partially_paid"
          //         ? "orange"
          //         : status === "unpaid"
          //         ? "red"
          //         : "blue";

          //     return <Tag color={color}>{status?.toUpperCase()}</Tag>;
          //   },
          // },
        ]}
        toolBarRender={() => (
          <Row>
            <Space>
              {/* <Col span={6}> */}
              <RangePicker
                onChange={(dates) => {
                  if (!dates) return;
                  setFilters({
                    ...filters,
                    dateFrom: dates[0].format("YYYY-MM-DD"),
                    dateTo: dates[1].format("YYYY-MM-DD"),
                  });
                }}
                presets={[
                  {
                    label: "Today",
                    value: [dayjs(), dayjs()],
                  },
                  {
                    label: "This Week",
                    value: [dayjs().startOf("week"), dayjs().endOf("week")],
                  },
                  {
                    label: "This Month",
                    value: [dayjs().startOf("month"), dayjs().endOf("month")],
                  },
                  {
                    label: "Last Month",
                    value: [
                      dayjs().subtract(1, "month").startOf("month"),
                      dayjs().subtract(1, "month").endOf("month"),
                    ],
                  },
                  {
                    label: "Last 6 Months",
                    value: [
                      dayjs().subtract(6, "month").startOf("month"),
                      dayjs().subtract(1, "month").endOf("month"),
                    ],
                  },
                  {
                    label: "This Year",
                    value: [dayjs().startOf("year"), dayjs().endOf("year")],
                  },
                  {
                    label: "Last Year",
                    value: [
                      dayjs().subtract(1, "year").startOf("year"),
                      dayjs().subtract(1, "year").endOf("year"),
                    ],
                  },
                ]}
              />
              <Select
                mode="multiple"
                placeholder="Select Item Type"
                onChange={(values) =>
                  setFilters({ ...filters, itemType: values.join(",") })
                }
                style={{ width: 250 }}
              >
                {itemTypes.map((p) => (
                  <Select.Option key={p} value={p}>
                    {p}
                  </Select.Option>
                ))}
              </Select>
              <Select
                mode="multiple"
                placeholder="Select Product"
                onChange={(values) =>
                  setFilters({ ...filters, sourceTable: values.join(",") })
                }
                style={{ width: 250 }}
              >
                {products.map((p) => (
                  <Select.Option key={p} value={p}>
                    {p}
                  </Select.Option>
                ))}
              </Select>
              {/* </Col> */}

              {/* <Col span={3}> */}
              <Button onClick={fetchData}>
                <FilterFilled /> Apply Filters
              </Button>
            </Space>
            <Space>
              <Button onClick={exportToCSV}>
                <ExportOutlined /> Export CSV
              </Button>
              <a ref={csvLinkRef} style={{ display: "none" }} />
            </Space>
          </Row>
        )}
      />
    </>
  );
}
